import React, { useState, useEffect } from 'react'
import { Select } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

import { GetSupportedPaymentCurrencies, handleCurrencyChange } from './index.utils'

export default function CurrencyInput({ currency, stripe_account_id, onChange }) {
    const [currencies, setCurrencies] = useState()
    const [selectedCurrency, setSelectedCurrency] = useState()

    useEffect(() => {
        GetSupportedPaymentCurrencies(stripe_account_id, setCurrencies)
    }, [])

    useEffect(() => {
        if (currency) {
            setSelectedCurrency(currency)
        }
    }, [currency])

    if (!currencies) {
        return <LoadingOutlined />
    }

    return (
        <Select
            style={{ width: '100%', marginBottom: '1em' }}
            showSearch
            value={selectedCurrency}
            onChange={(value) => handleCurrencyChange(value, setSelectedCurrency, onChange)}
        >
            {currencies.map((currency) => (
                <Select.Option key={currency} value={currency}>
                    {currency}
                </Select.Option>
            ))}
        </Select>
    )
}
